import { plans } from '../utils/collections';
import { handleMultiDocument } from '../utils/firebase';

const findByID = (id, arr) => arr.find((data) => data.id === id);

export const getRouteNames = (plan) =>
  plans
    .get()
    .then(handleMultiDocument)
    .then((docs) => findByID(plan, docs) || findByID('basic', docs))
    .then((data) => data.pages);
